import React from 'react';
import ExpenseBreadcrumbs from '../shared/ExpenseBreadcrumbs';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';

const UploadExpenseBreadcrumbs = () => {
  return (
    <ExpenseBreadcrumbs>
      <BreadcrumbItem>Upload Expense</BreadcrumbItem>
    </ExpenseBreadcrumbs>
  );
};

export default UploadExpenseBreadcrumbs;
